import { Link, Icon } from './index';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import './back-button.scss';

type BackButtonProps = {
  onClick: () => void;
  isDisabled?: boolean;
};

const BackButton = ({ onClick, isDisabled }: BackButtonProps) => {
  const { t } = useTranslation();
  const classnames = cx('content-submission__link--back', {
    'content-submission__link--disabled': isDisabled,
  });

  return (
    <Link
      className={classnames}
      onClick={onClick}
      aria-label={t('common.back')}
      tabIndex={0}
      onKeyDown={(e) => {
        if (['Enter', 'Spacebar', ' '].indexOf(e.key) !== -1) {
          e.stopPropagation();
          onClick();
        }
      }}
    >
      <Icon type="arrow_back" />
    </Link>
  );
};

export default BackButton;
